module.exports = __webpack_public_path__ + "4670012dca59e8f77d2ba55323a0cca0.svg";